import { resolveSemanticColor } from '@/theme/semanticTokens';
import type { Theme } from './types';

export const resolveChartPlotAreaBackgroundColor = (theme: Theme): string =>
  resolveSemanticColor(theme, 'pageBg');
